import React, { useEffect, useState } from "react";
import { WEBINAR_DATE_ISO } from "./copy";

const diff = () => {
  const d = new Date(WEBINAR_DATE_ISO).getTime() - Date.now();
  if (d <= 0) return null;
  return {
    days: Math.floor(d / 86400000),
    hours: Math.floor((d % 86400000) / 3600000),
    min: Math.floor((d % 3600000) / 60000),
    sec: Math.floor((d % 60000) / 1000),
  };
};

export const Countdown = ({ t }) => {
  const [left, setLeft] = useState(diff);
  useEffect(() => {
    const id = setInterval(() => setLeft(diff()), 1000);
    return () => clearInterval(id);
  }, []);
  if (!left) return null;
  const cells = [
    [left.days, t.countdown.days],
    [left.hours, t.countdown.hours],
    [left.min, t.countdown.min],
    [left.sec, t.countdown.sec],
  ];
  return (
    <div className="mb-6" data-testid="hero-countdown">
      <div className="mono accent text-[9px] tracking-[0.35em] mb-2">{t.countdown.until}</div>
      <div className="flex gap-2">
        {cells.map(([v, l], i) => (
          <div key={i} className="glass-card px-3 py-2 text-center min-w-[62px]">
            <div className="font-black text-2xl tabular-nums accent">{String(v).padStart(2, "0")}</div>
            <div className="mono text-[8px] tracking-[0.25em] text-white/35 mt-0.5">{l}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
